import { render } from "./DemandTemplateFormModal.vue?vue&type=template&id=9992140c"
import script from "./DemandTemplateFormModal.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script